import { select, call, put, takeLatest } from 'redux-saga/effects';
import * as constants from '../constants';
import { getApi } from './api';
import { handleError } from './error';
import { getToken } from './stateSelectors';

function* getInfomaterialStatus(action) {
    const token = yield select(getToken);
    // const {criteria} = action;

    try {
        const data = yield call(getApi, token, '/customers/infomaterial');
        yield put({ type: constants.GET_INFOMATERIAL_STATUS_SUCCESS, data });
    } catch (error) {
        yield put({ type: constants.GET_INFOMATERIAL_STATUS_ERROR, err: error });
        yield handleError(error);
    }
}

export default [takeLatest(constants.GET_INFOMATERIAL_STATUS, getInfomaterialStatus)];
